/**
 * Created by Zac on 6/04/2016.
 */

import inView from 'in-view';

$(() => {
    $('.js__accordion__panel__body').on('shown.bs.collapse', function () {
        $(this).addClass('active-accordion');

        if (!inView.is(this)) {
            $('html,body').animate({scrollTop: $(this).offset().top - 300}, 0);
        }
    });

    $('.js__accordion__panel__body').on('hidden.bs.collapse', function () {
        $(this).removeClass('active-accordion');
    })


    $('.accordion-heading').keypress(function (e) {
        if (e && e.which == 13) {
            $(this).click();
            // var target = $(this).attr('data-target')
            // setTimeout(()=>{
            //     $(target).focus()
            // },10)
        }
    })
});



// WEBPACK FOOTER //
// Glasshouse/Core/js/accordion.js